<body class="A4">
<!-- Each sheet element should have the class "sheet" -->
<!-- "padding-**mm" is optional: you can set 10, 15, 20 or 25 -->
<section class="sheet padding-10mm">
  <div class="logo d-flex align-items-center" *ngIf="campaign">
    <span class="campaign-name">{{campaign.name}}</span>
  </div>
  <div class="influencer-basic-info" *ngIf="influencer && canShowCampaignKpi">
    <app-influencer-basic-information
      *ngIf="influencer"
      [influencer]="influencer"
      [postCount]="campaignInfluencerKPI.post.value"
      [customKpi]="campaignInfluencerKPI"
      [showCountryFlagIcon]="true">
    </app-influencer-basic-information>
  </div>
  <pdf-viewer-footer></pdf-viewer-footer>
</section>
<section class="sheet padding-10mm" *ngIf="canShowInfluencerPostList">
  <pdf-viewer-header></pdf-viewer-header>
  <div class="post-list">
    <div class="content-header">{{ 'INFLUENCER.OVERVIEW' | translate }}</div>
    <app-post-list [postList]="influencerPostList"
                   [influencerGroupId]="groupId"
                   [previewMode]="true"
                   [columnWidth]="166"
                   [gutter]="0">
    </app-post-list>
  </div>
  <pdf-viewer-footer></pdf-viewer-footer>
</section>
<section class="sheet padding-10mm">
  <pdf-viewer-header></pdf-viewer-header>
  <div class="content-header">{{ 'INFLUENCER.ACTIVITY' | translate }}</div>
  <div class="activity-chart" *ngIf="campaignPostDailyKpis">
    <div class="activity-title">
      <span>{{'INFLUENCER.insight.activity_chart.title' | translate}}</span>
    </div>
    <div class="activity-line-chart-body">
      <achoo-line-chart [chartData]="campaignPostDailyKpis"
                        [legendXPosition]="1"
                        [legendYPosition]="-2"
                        [legendItemDistance]="-3"
                        [xLabelPaddingTop]="15"
                        [spacingBottom]="10">
      </achoo-line-chart>
    </div>
  </div>
  <div class="kpi-report-container">
    <kpi-report *ngIf="campaignInfluencerKPI"
      class="full-width"
      [kpi]="campaignInfluencerKPI"
      [showKpiStatus]="false"
    ></kpi-report>
  </div>
  <pdf-viewer-footer></pdf-viewer-footer>
</section>
<section class="sheet padding-10mm" *ngFor="let item of campaignPostPages; let i = index">
  <pdf-viewer-header></pdf-viewer-header>
  <div class="campaign-posts-container">
    <div class="influencer-section d-flex flex-column">
      <div class="header">
        <span>{{'pdf.campaign.post_list_title' | translate}}</span>
      </div>
      <div class="chart-content">
        <campaign-influencer-posts [posts]="getSubPostList(i)" [campaignInfluencerId]="campaignInfluencerId" [showHeader]="false" [pageIndex]="i"></campaign-influencer-posts>
      </div>
    </div>
  </div>
  <pdf-viewer-footer></pdf-viewer-footer>
</section>
<section class="sheet dynamic-height padding-10mm">
  <pdf-viewer-header></pdf-viewer-header>
  <div class="content-header">{{ 'INFLUENCER.DEMOGRAPHICS' | translate }}</div>
  <demographic-page
    #Demographics *ngIf="influencer"
    [demoInfluencerId]="influencer.id"
    [pieHeight]="195"
    [pieCenter]="[85, 45]"
    [pieSize]="130"
    [pieInnerSize]="95"
    [pieTitleStyling]="{fontSize: '0.82rem'}"
    [pieLegend]="{x: 23, y: 26, itemMarginBottom: 3, useHTML: true, enabledNavigation: false}">
  </demographic-page>
  <pdf-viewer-footer></pdf-viewer-footer>
</section>
<section class="sheet padding-10mm"></section>
</body>



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/campaign-pdf-viewer/campaign-pdf-viewer.component.html